var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEditActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2748_39460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5601 6.69V16.81",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18994 4.44H17.8799",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93994 16.81V6.69",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3099 19.06H7.18994",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63 2.75H3.25V6.13H6.63V2.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63 17.38H3.25V20.76H6.63V17.38Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2599 2.75H17.8799V6.13H21.2599V2.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2599 17.38H17.8799V20.76H21.2599V17.38Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43994 11.75H15.0599",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 14.56V8.94",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2748_39460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 19.5,
    fill: "white",
    transform: "translate(2.5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditActive);
export default __webpack_public_path__ + "static/media/ico-edit-active.188972e0c54e9e9e6b3f7c0efefd6c23.svg";
export { ForwardRef as ReactComponent };